import React from "react"
import classes from "css/Loading.module.css"
import { Portal } from "components"
import { AnimatePresence, motion } from "framer-motion"

const Loading = ({ show }) => {

	const variants = {
		initial: {
			y: 100
		},
		animate: {
			y: 0,
			transition: {
				duration: 0.5,
				bounce: 0.4,
				type: "spring"
			}
		},
		exit: {
			y: 300,
			transition: {
				type: "tween",
				ease: "backIn"
			}
		},
	}

	return (
		<Portal to='modal'>
			<AnimatePresence>
				{show && (
					<motion.div
						className={classes.Loading}
						initial={{
							opacity: 0,
						}}
						animate={{
							opacity: 1,
						}}
						exit={{
							opacity: 0,
						}}
					>
						<motion.div className={classes.wrap} variants={variants} initial="initial" animate="animate" exit="exit">
							<div className={classes.icon2}></div>
							<div className={classes.icon3}></div>
						</motion.div>
					</motion.div>
				)}
			</AnimatePresence>
		</Portal>
	)
}

const Loading2 = ({ show }) => {
	return (
		<Portal to='modal'>
			<AnimatePresence>
				{show && (
					<motion.div
						className={classes.Loading}
						initial={{
							opacity: 0,
						}}
						animate={{
							opacity: 1,
						}}
						exit={{
							opacity: 0,
						}}
					>
						<div className={classes.wrap}>
							<div className={classes.icon}>
								<div></div>
							</div>
						</div>
					</motion.div>
				)}
			</AnimatePresence>
		</Portal>
	)
}

export default Loading
